export const generateInvoiceNumber = (
  invoiceSequence: number,
  prefix?: string,
  suffix?: string
) => {
  const padding = 10 - (prefix?.length || 0) - (suffix?.length || 0);
  const invoiceSequenceString = zeroFill(invoiceSequence, padding);
  const invoiceNumber = `${prefix || ""}${invoiceSequenceString}${
    suffix || ""
  }`;
  return invoiceNumber;
};

function zeroFill(number: number, width: number) {
  width -= number.toString().length;
  if (width > 0) {
    return (
      new Array(width + (/\./.test(number.toString()) ? 2 : 1)).join("0") +
      number
    );
  }
  return number + ""; // always return a string
}
